var _rect, _path, _g, _path2, _g2, _path3, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankSaemaul(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 23,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10834_56771",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 8,
    width: 10,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47656 14.3402C5.47656 17.8669 8.33621 20.7266 11.8641 20.7266C12.9932 20.7266 14.0555 20.4325 14.9758 19.9194V15.7948C14.6011 16.2861 14.0819 16.6476 13.4911 16.8285C12.9003 17.0093 12.2676 17.0003 11.6822 16.8028C11.0967 16.6054 10.588 16.2293 10.2274 15.7275C9.86684 15.2258 9.67267 14.6236 9.67221 14.0058C9.67221 13.2327 9.97019 12.5272 10.4566 12.0016C9.93132 11.0365 9.65701 9.95487 9.65886 8.8561C9.65886 8.68179 9.66593 8.50591 9.67928 8.33474C7.22753 9.22671 5.47656 11.5783 5.47656 14.3402Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10834_56771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.47656 14.3402C5.47656 17.8669 8.33621 20.7266 11.8641 20.7266C12.9932 20.7266 14.0555 20.4325 14.9758 19.9194V15.7948C14.6011 16.2861 14.0819 16.6476 13.4911 16.8285C12.9003 17.0093 12.2676 17.0003 11.6822 16.8028C11.0967 16.6054 10.588 16.2293 10.2274 15.7275C9.86684 15.2258 9.67267 14.6236 9.67221 14.0058C9.67221 13.2327 9.97019 12.5272 10.4566 12.0016C9.93132 11.0365 9.65701 9.95487 9.65886 8.8561C9.65886 8.68179 9.66593 8.50591 9.67928 8.33474C7.22753 9.22671 5.47656 11.5783 5.47656 14.3402Z",
    fill: "url(#paint0_linear_10834_56771)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10834_56771",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 2,
    width: 14,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65626 8.85454C9.6544 9.95331 9.92872 11.0349 10.454 12C10.8418 11.5797 11.3433 11.281 11.8975 11.1404C12.4518 10.9997 13.0351 11.0231 13.5763 11.2077C13.2328 10.6877 13.0497 10.0781 13.0498 9.45481C13.05 8.61003 13.3858 7.79994 13.9833 7.2027C14.5807 6.60546 15.391 6.26999 16.2357 6.27009C16.8446 6.26991 17.4407 6.44431 17.9535 6.7726C18.4662 7.10089 18.8741 7.56932 19.1288 8.12236C19.6137 8.00736 20.1104 7.94951 20.6088 7.95C21.3764 7.95 22.1125 8.08506 22.7936 8.33318C22.5263 4.9447 19.6925 2.27702 16.2353 2.27702C12.6015 2.27702 9.65626 5.22226 9.65626 8.85454Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10834_56771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.65626 8.85454C9.6544 9.95331 9.92872 11.0349 10.454 12C10.8418 11.5797 11.3433 11.281 11.8975 11.1404C12.4518 10.9997 13.0351 11.0231 13.5763 11.2077C13.2328 10.6877 13.0497 10.0781 13.0498 9.45481C13.05 8.61003 13.3858 7.79994 13.9833 7.2027C14.5807 6.60546 15.391 6.26999 16.2357 6.27009C16.8446 6.26991 17.4407 6.44431 17.9535 6.7726C18.4662 7.10089 18.8741 7.56932 19.1288 8.12236C19.6137 8.00736 20.1104 7.94951 20.6088 7.95C21.3764 7.95 22.1125 8.08506 22.7936 8.33318C22.5263 4.9447 19.6925 2.27702 16.2353 2.27702C12.6015 2.27702 9.65626 5.22226 9.65626 8.85454Z",
    fill: "url(#paint1_linear_10834_56771)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_10834_56771",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 7,
    width: 10,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1312 8.12391C19.3237 8.54173 19.4231 8.99636 19.4225 9.45637C19.4234 10.079 19.2405 10.6881 18.8968 11.2073C19.2038 11.104 19.5254 11.0513 19.8493 11.0511C20.2373 11.0511 20.6215 11.1275 20.9799 11.276C21.3384 11.4245 21.6641 11.6421 21.9384 11.9165C22.2127 12.1909 22.4303 12.5166 22.5788 12.8751C22.7272 13.2336 22.8036 13.6178 22.8035 14.0058C22.8032 14.7891 22.4919 15.5403 21.9379 16.0941C21.3839 16.648 20.6326 16.9591 19.8493 16.9592C19.3945 16.9596 18.9458 16.8549 18.5382 16.6531C18.1307 16.4513 17.7753 16.1579 17.5 15.796V19.9194C18.4511 20.4499 19.5223 20.7278 20.6113 20.7266C24.1392 20.7266 26.9988 17.8669 26.9988 14.3402C26.9988 10.8112 24.1392 7.95156 20.6113 7.95156C20.1129 7.95107 19.6162 8.00892 19.1312 8.12391Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_10834_56771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1312 8.12391C19.3237 8.54173 19.4231 8.99636 19.4225 9.45637C19.4234 10.079 19.2405 10.6881 18.8968 11.2073C19.2038 11.104 19.5254 11.0513 19.8493 11.0511C20.2373 11.0511 20.6215 11.1275 20.9799 11.276C21.3384 11.4245 21.6641 11.6421 21.9384 11.9165C22.2127 12.1909 22.4303 12.5166 22.5788 12.8751C22.7272 13.2336 22.8036 13.6178 22.8035 14.0058C22.8032 14.7891 22.4919 15.5403 21.9379 16.0941C21.3839 16.648 20.6326 16.9591 19.8493 16.9592C19.3945 16.9596 18.9458 16.8549 18.5382 16.6531C18.1307 16.4513 17.7753 16.1579 17.5 15.796V19.9194C18.4511 20.4499 19.5223 20.7278 20.6113 20.7266C24.1392 20.7266 26.9988 17.8669 26.9988 14.3402C26.9988 10.8112 24.1392 7.95156 20.6113 7.95156C20.1129 7.95107 19.6162 8.00892 19.1312 8.12391Z",
    fill: "url(#paint2_linear_10834_56771)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10834_56771",
    x1: 11.1856,
    y1: 20.7849,
    x2: 8.98677,
    y2: 8.31471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471735,
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176FC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10834_56771",
    x1: 9.22284,
    y1: 8.83435,
    x2: 21.5904,
    y2: 4.33294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471735,
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176FC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10834_56771",
    x1: 23.4526,
    y1: 8.52261,
    x2: 21.2611,
    y2: 20.9511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471735,
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176FC1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankSaemaul);
export default __webpack_public_path__ + "static/media/BankSaemaul.5814719ab5d2eb14b6c6ab70343c9056.svg";
export { ForwardRef as ReactComponent };